import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import withRouter from "../../../HOC/withRouter";
import get from "lodash/get";
import { getTouchPointThumb, getTouchPointThumbFallback } from "../../../utils/imageService";
import { promisify } from "../../../utils/promisify";
import { BrandificationImageFallback } from "../../../components";
import Question from "./Question";
import QuestResult from "./QuestResult";

const DailyQuestContainer = ({ navigate, quest, closeModal, showQuestAnimation, answerQuest, client }) => {
  const [isAnswered, setIsAnswered] = useState(false);

  const dailyQuest = get(quest, "dailyQuest", {});
  const marketGoal = get(quest, "marketGoal", {});
  const strikes = get(quest, "strikes", 0);

  const answerQuestion = value => {
    const marketGoalId = marketGoal._id;
    const touchpointId = dailyQuest.touchpointId._id;
    promisify(answerQuest, { marketGoalId, touchpointId, answer: value }).then(res => setIsAnswered(true));
  };

  const viewTouchPoint = () => {
    const touchpointId = dailyQuest.touchpointId._id;
    navigate(`/touchpoint/${touchpointId}`);
    closeModal();
  };

  const goToHome = () => {
    navigate("/");
    closeModal();
    showQuestAnimation();
  };

  return (
    <div className="quest-container">
      <div className="quest-header">
        <div className="close-icon" onClick={closeModal}>
          &#10006;
        </div>
        <div className="container">
          <BrandificationImageFallback
            src={getTouchPointThumb(dailyQuest.touchpointId)}
            fallbackImage={getTouchPointThumbFallback(dailyQuest.touchpointId)}
            className={`${
              !!dailyQuest.touchpointId && dailyQuest.touchpointId.mediaURLs.length ? "image" : "no-image"
            }`}
          />
        </div>
      </div>
      <div className="quest-body">
        {isAnswered ? (
          <QuestResult dailyQuest={dailyQuest} viewTouchPoint={viewTouchPoint} goToHome={goToHome} />
        ) : (
          <Question
            dailyQuest={dailyQuest}
            marketGoal={marketGoal}
            strikes={strikes}
            answerQuestion={answerQuestion}
            lblBrandRules={client.lblBrandRule}
            client={client}
          />
        )}
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(DailyQuestContainer));
